<script lang="ts" setup>
import type {PriceCard} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import CheckGreen from '~/assets/icons/check-green.svg?component'
import Popular from '~/assets/popular.svg?component'
import CheckHighlighted from '~/assets/check-accentuated.svg?component'

defineProps<{
  price: Populated<PriceCard>
}>()
</script>

<template>
  <div
    class="flex w-full max-w-xs flex-col justify-center rounded-lg border border-gray-200 bg-white text-center shadow-lg transition-all hover:border-main-600 md:max-w-md lg:w-96"
  >
    <div class="relative mb-6 mt-6 p-4 text-center">
      <span v-if="price.oldPrice" class="text-xl font-bold text-red-500 line-through">
        {{ price.oldPrice }} &#8364;
      </span>

      <Popular class="absolute -top-14 left-3/4 h-14 -translate-x-1/2 transform" v-if="price.popular" />

      <Heading v-if="price.price" as="h2" size="large">{{ price.price }} &#8364;</Heading>
      <Heading as="h4" size="medium">{{ price.title }}</Heading>

      <Paragraph v-if="price.additionalDesc" size="small" class="mb-6 p-2 text-center">
        {{ price.additionalDesc }}
      </Paragraph>
      <Paragraph size="small" class="mb-6 p-2 text-center">{{ price.description }}</Paragraph>

      <ul class="text-gray-600">
        <li
          v-for="option in price.options"
          :key="option.title"
          class="flex list-none items-center gap-2 rounded-md p-2 text-left"
        >
          <CheckGreen v-if="!option.highlighted" class="h-6 w-6 flex-shrink-0" />
          <CheckHighlighted v-else class="h-6 w-6 flex-shrink-0" />
          {{ option.title }}
        </li>
      </ul>
    </div>

    <div class="flex justify-center border-t bg-gray-100 p-6">
      <Action
        class="w-full"
        :intent="price.action?.intent"
        :size="price.action?.size"
        as="link"
        :to="price.action?.href ?? '/contact'"
        >{{ price.action?.label }}</Action
      >
    </div>
  </div>
</template>
